import moment from 'moment'

export const USER_TRANSACTIONS_LIST_PATH = '/api/user-transactions'

export type UserTransactionsListFilters = {
  searchStr: string
  chargeYear: string
  chargeMonthName: string
}

export type UserTransactionsListPagination = {
  page: number
  limit?: number
  sort_by?: string
  sort_order?: string
}

export type UserTransactionsListQueryParams = UserTransactionsListPagination & {
  search_str: string
  year?: number
  month?: number
}

/**
 * GET `/api/user-transactions` with query params.
 * Charge Date: year-only sends `year`; month-only sends `month` and current calendar `year`;
 * both send selected values; neither omits both.
 */
export function buildUserTransactionsListQueryParams(
  filters: UserTransactionsListFilters,
  pagination: UserTransactionsListPagination
): UserTransactionsListQueryParams {
  const params: UserTransactionsListQueryParams = {
    page: pagination.page,
    limit: pagination.limit,
    sort_by: pagination.sort_by,
    sort_order: pagination.sort_order,
    search_str: filters.searchStr.trim(),
  }

  const yearStr = filters.chargeYear.trim()
  const monthName = filters.chargeMonthName.trim()
  const hasYear = Boolean(yearStr)
  const hasMonth = Boolean(monthName)

  if (hasYear) {
    const year = Number(yearStr)
    if (Number.isInteger(year) && year > 0) {
      params.year = year
    }
  }

  if (hasMonth) {
    const monthMoment = moment(monthName, 'MMMM', true)
    if (monthMoment.isValid()) {
      params.month = monthMoment.month() + 1
      if (!hasYear) {
        params.year = moment().year()
      }
    }
  }

  return params
}
